import React from 'react';
import './AboutUs.css';

export default function AboutUs() {
  return (
    <div className="about-page">
      {/* Hero */}
      <section className="about-hero">
        <div className="about-hero-inner">
          <span className="about-kicker">ABOUT SILWREN™</span>
          <h1>Intelligence, woven in silicon —<br/>not bolted on top.</h1>
          <p>We are a research-first company building the next layer of AI infrastructure: Smart Agents that reason, Convolutional Neural Networks that see invariantly, and Robotics that acts.</p>
        </div>
        <div className="about-hero-visual">
          <div className="about-stat"><b>2026</b><span>Founded in Pune</span></div>
          <div className="about-stat"><b>3</b><span>Core Pillars</span></div>
          <div className="about-stat"><b>1</b><span>Mission: Create Smart Products</span></div>
        </div>
      </section>

      {/* Story */}
      <section className="about-section">
        <div className="about-grid">
          <div>
            <h2>Our Story</h2>
          </div>
          <div className="about-text">
            <p><b>Silwren™</b> is a research-driven technology company specializing in Machine Learning, Artificial Intelligence, Smart Agents, Computer Vision, and Robotics.</p>
            <p> Our mission is to transform <b>cutting-edge</b> research into innovative products and solutions that address real-world challenges across industries.</p>
            <p>With a strong focus on innovation and technological excellence, <b>Silwren™</b> develops intelligent systems capable of autonomous decision-making, advanced perception, and adaptive learning. <br/>Our expertise spans the design and development of <b>Smart Agent</b> platforms, <b>Convolutional Neural Network (CNN)</b>-based computer vision solutions, and next-generation <b>robotic systems</b>.</p>
          </div>
        </div>
      </section>

      {/* Mission / Vision / Values */}
      <section className="about-cards">
        <div className="about-card">
          <div className="icon">🎯</div>
          <h3>Mission</h3>
          <p>Develop reliable, scalable, and intelligent products that solve real-world problems.</p>
        </div>
        <div className="about-card featured">
          <div className="icon">👁️</div>
          <h3>Vision</h3>
          <p>Create intelligent technologies that enhance human capabilities, automate complex processes, and accelerate digital transformation.</p>
        </div>
        <div className="about-card">
          <div className="icon">⚡</div>
          <h3>Values</h3>
          <p>Research rigor, deliver best product.</p>
        </div>
      </section>

      {/* Pillars */}
      <section className="about-pillars">
        <h2>What We Build</h2>
        <div className="pillars-grid">
          <div className="pillar">
            <h4>🧠 Smart Agents</h4>
            <p>We build intelligent agent systems that can analyze information, make decisions, automate workflows, and collaborate with users to improve productivity and operational efficiency.</p>
          </div>
          <div className="pillar">
            <h4>👁️ Computer Vision</h4>
            <p>Our research and development efforts leverage Convolutional Neural Networks (CNNs) and deep learning techniques to create advanced image and video analysis solutions for object detection, classification, tracking, quality inspection, and visual intelligence applications.</p>
          </div>
          <div className="pillar">
            <h4>🦾 Robotics</h4>
            <p>We develop intelligent robotic solutions that combine AI, machine learning, sensor technologies, and automation to enable autonomous operation in industrial, commercial, and research environments.</p>
          </div>
        </div>
      </section>

      {/* Team */}
      <section className="about-team">
        <h2>Built with Us</h2>
        <p className="team-sub">Our expertise is in LLM, agents, robotics and distributed systems. We also provide services to organisations in building AI products.</p>
        {/* <div className="team-grid">
          <div></div>
          <div className="team-card"> */}
            {/* <div className="team-avatar">VC</div> */}
            {/* <h4>Vikas Choudhary</h4>
            <span>Founder</span>
            <p>Silwren™</p> */}
            {/* <p>Building Silwren™ core stack — agents, vision and robotics.</p> */}
          {/* </div> */}
          {/* <div className="team-card">
            <div className="team-avatar">RA</div>
            <h4>Research Team</h4>
            <span>Commutative Intelligence</span>
            <p>Researching invariant perception and efficient inference.</p>
          </div> */
          /* <div className="team-card hiring">
            <div className="team-avatar">+</div>
            <h4>We are hiring</h4>
            <span>ML, Robotics, Full-stack</span>
            <p>Join us in Pune. hello@silwren.ai</p>
          </div> */}
        {/* </div> */}
      </section>

      {/* CTA */}
      {/* <section className="about-cta">
        <div className="about-cta-card">
          <h2>Want to build with us?</h2>
          <p>let's talk.</p>
          <div className="cta-row">
            <a href="mailto:contact@silwren.com" className="btn-white">Connect to Us</a>
            <span>Pune, Maharashtra, India</span>
          </div>
        </div>
      </section> */}
    </div>
  );
}